import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "16",
  viewbox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5 14H3.5C3.225 14 3 14.225 3 14.5V15.5C3 15.775 3.225 16 3.5 16H16.5C16.775 16 17 15.775 17 15.5V14.5C17 14.225 16.775 14 16.5 14ZM18.5 4C17.6719 4 17 4.67188 17 5.5C17 5.72187 17.05 5.92813 17.1375 6.11875L14.875 7.475C14.3938 7.7625 13.7719 7.6 13.4937 7.1125L10.9469 2.65625C11.2812 2.38125 11.5 1.96875 11.5 1.5C11.5 0.671875 10.8281 0 10 0C9.17188 0 8.5 0.671875 8.5 1.5C8.5 1.96875 8.71875 2.38125 9.05313 2.65625L6.50625 7.1125C6.22812 7.6 5.60313 7.7625 5.125 7.475L2.86562 6.11875C2.95 5.93125 3.00312 5.72187 3.00312 5.5C3.00312 4.67188 2.33125 4 1.50312 4C0.675 4 0 4.67188 0 5.5C0 6.32812 0.671875 7 1.5 7C1.58125 7 1.6625 6.9875 1.74063 6.975L4 13H16L18.2594 6.975C18.3375 6.9875 18.4188 7 18.5 7C19.3281 7 20 6.32812 20 5.5C20 4.67188 19.3281 4 18.5 4Z",
  fill: "#2650A0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}